import { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { Outlet, useMatches } from 'react-router-dom';
import { ALL_PAGES } from '../../constants/app';

export function HelmetLayout() {
  const matches = useMatches();
  const pageId = matches[matches.length - 1].id;

  const title = useMemo(() => {
    return ALL_PAGES.find((p) => p.id === pageId)?.name;
  }, [pageId]);

  return (
    <>
      <Helmet>
        <title>FSM {title ? `- ${title}` : ''}</title>
      </Helmet>
      <Outlet />
    </>
  );
}
